// External libraries
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// CSS
import "./forms.css";

function FormButton(props) {
    const getClass = () => {
        let className = props.Inline ? "eone-ui-form-button-inline" : "eone-ui-form-button";
        if (props.Class) {
            className = className + " " + props.Class;
        }
        return className;
    };
    if (props.Visible !== undefined && !props.Visible) return null;

    if (props.Icon) {
        return (
            <div className="eone-ui-form-group">
                <button type="button" className={getClass()} disabled={props.Disabled} onClick={props.OnClick} title={props.Title} data-testid={props.DataTestId}>
                    <FontAwesomeIcon icon={props.Icon} spin={props.IconSpin} fixedWidth />
                    <label className="eone-ui-form-button-label eone-ui-form-button-label-with-icon">{props.Label}</label>
                </button>
            </div>

        );
    }
    return (
        <div className="eone-ui-form-group">
            <button type="button" className={getClass()} disabled={props.Disabled} onClick={props.OnClick} title={props.Title} data-testid={props.DataTestId}>
                <label className="eone-ui-form-button-label">{props.Label}</label>
            </button>
        </div>
    )
}

export {FormButton};
